<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="administrator"
      :validate-on-rule-change="false"
      label-position="right"
      label-width="130px"
      style="width: 570px"
    >
      <el-form-item label="原密码" prop="old_password">
        <el-input v-model="administrator.old_password" maxlength="16" show-word-limit clearable/>
      </el-form-item>

      <el-form-item label="新密码" prop="password">
        <el-input v-model="administrator.password" maxlength="16" show-word-limit clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { updatePassword } from '@/api/administrator';

export default {
  name: RouteConfig.administratorEditPassword.name,
  data: () => ({
    isSaving: false,
    administrator: {
      old_password: '',
      password: '',
    },
    rules: {
      old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
      password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
    },
  }),
  computed: {
    ...mapGetters([
      'userId',
    ]),
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        if (this.administrator.old_password === this.administrator.password) return this.$message.error('新密码与原密码不一致！');

        this.isSaving = true;
        const { ...administrator } = this.administrator;

        const { isError } = await updatePassword(administrator);
        if (isError) return this.isSaving = false;

        // logout 已携带当前页面作为 redirect 并跳转登录页，无需（也无法）再手动 push
        await this.$store.dispatch('user/logout', { is_not_auto_login: 1 });
        this.$message.success('已成功修改密码，请重新登录！');
        this.isSaving = false;
      });
    },
  },
};
</script>
